import * as React from "react"

import dayjs from "dayjs"
import styles from "./ConversationAiPausedBanner.module.scss"
import AppText from "@components/general/AppText/AppText.tsx"
import DsButton from "@components/general/DsButton/DsButton.tsx"

import { useTranslation } from "react-i18next"
import { useAppDateTime } from "@hooks/useAppDateTime.ts"

export interface IConversationAiPausedBannerProps {
	pausedUntil?: string | null
	disabled?: boolean
	onResume: () => void
}

const ConversationAiPausedBanner: React.FC<
	IConversationAiPausedBannerProps
> = ({ pausedUntil, disabled = false, onResume }) => {
	const { t } = useTranslation()
	const { formatDate } = useAppDateTime()

	const resumeTime = React.useMemo(() => {
		if (!pausedUntil || !dayjs(pausedUntil).isValid()) return undefined

		return formatDate({
			date: pausedUntil,
			format: "HH:mm",
			zone: "Local",
		})
	}, [formatDate, pausedUntil])

	return (
		<div className={styles.ai_paused_banner}>
			<div className={styles.ai_paused_banner_text}>
				<AppText
					className={styles.ai_paused_banner_message}
					textKey="message_chat_ai_paused_banner"
				/>

				{resumeTime && (
					<AppText className={styles.ai_paused_banner_resume_time}>
						{t("message_chat_ai_paused_banner_resume_time", {
							time: resumeTime,
						})}
					</AppText>
				)}
			</div>

			<DsButton
				className={styles.ai_paused_banner_action}
				disabled={disabled}
				onClick={onResume}
				textKey="resume_ai"
				type="text"
			/>
		</div>
	)
}

export default React.memo(ConversationAiPausedBanner)
